<template>
  <div class="main-content">
    <!-- <el-tabs class="el-tabs-common" v-model="current" @tab-click="changeTab">
      <el-tab-pane
        v-for="(item, index) in types"
        :key="index"
        :name="item.type"
        :label="item.name"
      ></el-tab-pane>
    </el-tabs> -->
    <div
      v-if="['1', '2'].includes(current)"
      class="tab-content"
      :class="{ 'no-tabs': !types.length }"
    >
      <div class="vip-tip" v-if="vipCourseCount > 0 && $store.state.user_info.is_vip">
        <span>课程中有会员课，会员将于{{ vipEndDate }}过期。</span>
        <router-link :to="{ name: 'MemberVip' }" class="lnk-vip" v-if="vipEndDateCount <= 3">
          去续费
        </router-link>
      </div>
      <div
        ref="courses"
        class="courses"
        :class="{ courseIsSticky: isSticky }"
        v-if="courses.length"
      >
        <template v-if="courses.length > 3">
          <div class="nav nav-left" @click="navLeft" v-if="navLeftIndex > 0">
            <i class="el-icon-arrow-left" />
          </div>
          <div class="nav nav-right" @click="navRight" v-if="navLeftIndex * 2 < courses.length - 3">
            <i class="el-icon-arrow-right" />
          </div>
        </template>
        <div style="padding-top: 24px; overflow: hidden">
          <div
            class="item-container clearfix"
            :style="{
              width: courses.length * 300 + 'px',
              marginLeft: -navLeftIndex * 600 + 'px',
            }"
          >
            <div
              class="item"
              :class="{
                selected: item.course_id == currentCourse.course_id,
                invalid: item.is_vip_course == 1 && !isVipUser && !item.is_buy_order,
              }"
              v-for="(item, index) in courses"
              :key="item.course_id"
              @click="changeCourse(index)"
            >
              <img
                v-if="item.valid_status != 1"
                class="expire"
                src="@/modules/stu/images/expire@2x.png"
              />
              <div class="content">
                <img
                  class="vip-invalid"
                  v-if="item.is_vip_course == 1 && !isVipUser && !item.is_buy_order"
                  src="../../images/invalid@3x.png"
                  style="width: 79px"
                />
                <div
                  class="title"
                  :class="{ 'has-vip': item.is_vip_course }"
                  @mouseover="item.showHover = true"
                  @mouseleave="item.showHover = false"
                >
                  <img
                    class="vip"
                    v-if="item.is_vip_course"
                    src="@/assets/images/course/vip-index@3x.png"
                  />
                  <span class="multi-line-1">{{ item.title }}</span>
                  <div v-show="item.showHover" class="hoverTitle">
                    {{ item.title }}
                  </div>
                </div>
                <div class="time">
                  <span v-if="item.start_play_date > 0">
                    {{ new Date(item.start_play_date * 1000).format('MM月dd日') }}-{{
                      new Date(item.end_play_date * 1000).format('MM月dd日')
                    }}
                  </span>
                  <span v-if="item.course_type != 3 && item.start_play_date > 0" class="line">
                    |
                  </span>
                  <span v-if="item.course_type != 3"> 共{{ item.section_num }}课节 </span>
                </div>
                <div class="progress-wrap" v-if="false">
                  <div class="progress">
                    <div
                      class="progress-current"
                      :style="{
                        width: (item.progress_rate || 0) + '%',
                      }"
                    ></div>
                  </div>
                  <span>已学习{{ item.progress_rate || 0 }}%</span>
                  <div class="right">
                    <span v-if="item.course_type == 3">
                      <span v-if="item.now_course_num > 0">正在直播</span>
                      <span v-else-if="item.today_course_num > 0"> 今日有直播 </span>
                    </span>
                    <span v-else>
                      <span v-if="item.now_course_num > 0">正在上课</span>
                      <span v-else-if="item.today_course_num > 0"> 今日有课 </span>
                    </span>
                  </div>
                </div>
                <div class="valid">
                  <span v-highlight="item.valid_date_txt"></span>
                  <!-- <span v-if="item.valid_type == 1">长期有效</span>
                  <template v-else>
                    <span>{{ item.valid_end_time.replace(/-/g, '/') }}</span>
                    <span v-if="item.valid_status != 1">到期</span>
                    <template v-if="item.end_days >= 0">
                      <span>（</span>
                      <template v-if="item.end_days > 2">
                        <span>还有</span>
                        <span class="days">{{ item.end_days }}</span>
                        <span>天</span>
                      </template>
                      <span class="days" v-else-if="item.end_days == 0" style="margin: 0">
                        今天
                      </span>
                      <span class="days" v-else-if="item.end_days == 1" style="margin: 0">
                        明天
                      </span>
                      <span class="days" v-else-if="item.end_days == 2" style="margin: 0">
                        后天
                      </span>
                      <span>到期）</span>
                    </template>
                  </template> -->
                </div>
              </div>
            </div>
          </div>
        </div>
        <div style="clear: both"></div>
      </div>
      <EmptyNew title="当前还没有课程可以学习，快去报名课程吧～" v-else></EmptyNew>
      <div class="detail" v-if="detail.course && detail.course.course_id">
        <div ref="header" class="header" :class="{ headerIsSticky: isSticky }">
          <div class="teacher" :class="{ moreSpace: showHoverQRCode }">
            <template v-if="detail.course.teacher_name">
              <div class="lecture" v-for="item in detail.course.teacher_name" :key="item">
                <img
                  src="//cdn.yuaiweiwu.com/fe/imgs/5fd17960-436b-11ef-973d-09b2b5c5fcc8-lecture_default.png"
                />
                <p>{{ item }}</p>
                <span class="icon">主讲</span>
              </div>
            </template>
            <div
              class="counseling"
              @mouseover="handleGetMouse(detail.course.assistant_teacher, 'over')"
              @mouseleave="handleGetMouse(detail.course.assistant_teacher, 'leave')"
              v-if="detail.course.assistant_teacher"
            >
              <img
                :src="
                  detail.course.assistant_teacher.assistant_avatar ||
                  '//cdn.yuaiweiwu.com/fe/imgs/70739780-436b-11ef-973d-09b2b5c5fcc8-counseling_default.png'
                "
              />
              <p>
                {{ (detail.course.assistant_teacher.assistant_name || '').substr(0, 6) }}
              </p>
              <span class="icon">辅导</span>
              <div v-show="showHoverQRCode" class="hoverQRCode">
                <img :src="detail.course.assistant_teacher.wechat_work_qr_code" />
              </div>
            </div>
          </div>
          <div class="evaluate">
            <a class="comment" @click="beginComment">
              {{ detail.course.is_comment == 1 ? '查看评价' : '评价课程' }}
            </a>
            <template v-if="!$store.state.desktop">
              <!-- <span class="line" />
              <router-link
                :to="{
                  name: 'CourseShow',
                  params: { id: detail.course.course_id },
                }"
              >
                查看课程详情
              </router-link> -->
              <template v-if="course_qrcode_title">
                <span class="line" />
                <a @click="showQrcodeModal = true">{{ course_qrcode_title }}</a>
              </template>
              <!-- 20240509隐藏 隐藏课程 -->
              <!-- <template
                v-if="type != 'expire' && currentCourse.course_type != 2"
              >
                <span class="line">|</span>
                <a @click="deleteCourse">
                  {{ type == "open" ? "隐藏课程" : "取消隐藏" }}
                </a>
              </template> -->
            </template>
          </div>
        </div>
        <!--  -->
        <div class="chapter" v-if="detail.chapters" :class="{ morePaddingTop: isSticky }">
          <el-collapse
            class="chapter-collapse"
            v-model="activeNames"
            @change="handleCollapseChange"
          >
            <!-- :title="chapter.title" -->
            <el-collapse-item
              :id="chapter.id"
              v-for="chapter in detail.chapters"
              :key="chapter.id"
              :name="chapter.id"
              v-loading="chapter.chapterLoading"
            >
              <template slot="title">
                <div class="chapter-collapse-title">
                  <span class="show-name">{{ chapter.title }}</span>
                  <span class="show-count">含{{ chapter.periods_num }}节课</span>
                </div>
              </template>
              <!-- <h1 v-for="period in chapter.child" :key="period.id">{{ period.id }}</h1> -->
              <MemberStudyPeriod
                v-for="period in chapter.periods"
                :key="period.id"
                :period="period"
                :course_id="currentCourse.course_id"
                :course_title="currentCourse.title"
                :course_type="currentCourse.course_type"
                :course="detail.course"
              />
            </el-collapse-item>
          </el-collapse>

          <!-- <div
            class="chapter"
            :class="{ expand: chapterExpand[chapter.id] == 1 }"
            v-for="chapter in detail.chapter"
            :key="chapter.id"
          >
            <div class="clear chapter-header" @click="toggleExpand(chapter.id)">
              <div class="flag f-left"></div>
              <div class="title f-left">{{ chapter.title }}</div>
            </div>
            <div class="periods" v-if="chapter.child && chapter.child.length">
              <MemberStudyPeriod
                v-for="period in chapter.child"
                :key="period.id"
                :period="period"
                :course_id="currentCourse.course_id"
                :course_title="currentCourse.title"
                :course_type="currentCourse.course_type"
                :course="detail.course"
              ></MemberStudyPeriod>
            </div>
          </div> -->
        </div>
        <div v-else class="period-list-only" :class="{ morePaddingTop: isSticky }">
          <template v-if="detail.periods.length">
            <MemberStudyPeriod
              v-for="period in detail.periods"
              :key="period.id"
              :period="period"
              :course_id="currentCourse.course_id"
              :course_type="currentCourse.course_type"
              :course="detail.course"
            ></MemberStudyPeriod>
          </template>
          <EmptyNew title="该课程暂未设置课节" v-else></EmptyNew>
        </div>
        <el-pagination
          v-if="totalPage > 1"
          class="center pager"
          background
          layout="prev, pager, next"
          :total="pageSize * totalPage"
          :current-page="pageNum"
          @current-change="changePage"
        ></el-pagination>
      </div>
      <div class="study-exam" v-if="this.currentCourse.course_id && exams.length">
        <p class="title">课程考试</p>
        <CourseExam
          :courseId="currentCourse.course_id"
          v-for="exam in exams"
          :key="exam.id"
          :exam="exam"
        ></CourseExam>
      </div>
    </div>
    <template v-else>
      <div v-for="course in courses" :key="course.id">
        <OpenCourseItem @onComment="beginComment" :course="course"></OpenCourseItem>
      </div>
    </template>
    <el-dialog class="comment-dialog" title="评价" :visible.sync="showCommentDialog" width="784px">
      <div v-if="detail.course">
        <div class="name item">课程名称：{{ detail.course.title }}</div>
        <div class="item">
          <label>星级：</label>
          <!--        el-rate disabled为true时，动态值不生效  -->
          <el-rate v-model="commentInfo.grade"></el-rate>
          <div class="mask" v-if="detail.course.is_comment == 1"></div>
          <!--          -->
        </div>
        <div class="item">
          <label>评价内容：</label>
          <br />
          <el-input
            type="textarea"
            :rows="6"
            placeholder="请输入对课程的评价内容，最多500字"
            v-model="commentInfo.content"
            :maxlength="500"
            :readonly="detail.course.is_comment == 1"
          ></el-input>
        </div>
        <div slot="footer" class="dialog-footer">
          <el-button type="primary" @click="submitComment">确 定</el-button>
        </div>
      </div>
    </el-dialog>
    <el-dialog class="vip-dialog" title="提示" :visible.sync="showVipDialog" width="500px">
      <div>
        <i class="el-icon-warning" style="color: #e6a23c"></i>
        {{ vipDialogInfo }}
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button
          type="primary"
          @click="
            deleteCourse();
            showVipDialog = false;
          "
        >
          移除课程
        </el-button>
        <el-button type="primary" @click="$router.push({ name: 'MemberVip' })">
          续费会员
        </el-button>
      </div>
    </el-dialog>
    <el-dialog
      class="dialog-qrcode"
      :visible.sync="showQrcodeModal"
      :close-on-click-modal="false"
      width="278px"
    >
      <img :src="course_qrcode_img" />
      <a class="close" @click="showQrcodeModal = false"></a>
    </el-dialog>
    <div class="type-wrap">
      <el-dropdown
        @command="handleSelectCourseAttr"
        @visible-change="handleVisibelChange"
        :class="{ onshowUpIcon: showDropUp }"
      >
        <span class="el-dropdown-link">
          <span :class="{ onColor: attrTitleOnColor }">
            {{ attrTitle }}
          </span>
          <i class="el-icon-caret-bottom" :class="{ onColor: attrTitleOnColor }"></i>
        </span>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item
            v-for="item in course_attrs"
            :key="item.name"
            :command="item"
            :class="{ onBackGround: item.name === attrTitle }"
          >
            <span :class="{ onColor: item.name === attrTitle }">
              {{ item.name }}
            </span>
          </el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
      <!-- <span
        class="open"
        :class="{ active: type == 'open' }"
        @click="changeType('open')"
      >
        我的课程
      </span>
      <span class="expire" :class="{ active: type == 'expire' }" @click="changeType('expire')">
        已过期
      </span> -->
      <!-- <span
        class="hidden"
        :class="{ active: type == 'hidden' }"
        @click="changeType('hidden')"
      >
        已隐藏
      </span> -->
    </div>
    <MemberCertGet ref="cert"></MemberCertGet>
  </div>
</template>
<script>
import MemberStudyPeriod from '../../components/MemberStudyPeriod.vue';
import MemberCertGet from '../../components/MemberCertGet.vue';
import CourseExam from '../../components/CourseExam.vue';
import OpenCourseItem from '@stu/views/member/components/OpenCourseItem.vue';
import EmptyNew from '@/components/EmptyNew';
import { triggerLoaded } from '@/components/LoadContainer.vue';
import util from '@/utils/plugins';

const PAGE_SIZE = 10;
export default {
  name: 'MemberStudy',
  components: {
    MemberStudyPeriod,
    MemberCertGet,
    CourseExam,
    EmptyNew,
    OpenCourseItem,
  },
  data() {
    return {
      isSticky: false,
      courseOffsetTop: 0,
      course_attrs: [
        {
          name: '我的课程',
          value: 'open',
        },
        {
          name: '已过期',
          value: 'expire',
        },
      ],
      showDropUp: false,
      attrTitle: '我的课程',
      attrTitleOnColor: false,
      showHoverQRCode: false,
      user: {},
      current: '2',
      vipCourseCount: 0,
      vipEndDateCount: 0,
      vipEndDate: 0,
      types: [],
      courses: [],
      currentCourse: {},
      currentIndex: 0,
      navLeftIndex: 0,
      detail: {},
      showCommentDialog: false,
      commentInfo: {
        grade: 0,
        content: '',
      },
      chapterExpand: {},
      showVipDialog: false,
      vipDialogInfo: '',
      isVipUser: false,
      course_qrcode_title: '',
      course_qrcode_img: '',
      showQrcodeModal: false,
      type: 'open',
      showCertGetModal: true,
      exams: [],
      totalPage: 1,
      pageNum: 1,
      pageSize: PAGE_SIZE,
      activeNames: [],
    };
  },
  directives: {
    highlight(el, binding) {
      const text = binding.value;
      if (!text) return '';
      const regex = /#(.*?)#/g;
      el.innerHTML = text.replace(
        regex,
        // eslint-disable-next-line no-useless-escape
        '<span style="color: #ff2d28;">\$1</span>',
      );
    },
  },
  computed: {
    commonSetting() {
      return this.$store.state.commonSetting;
    },
  },
  watch: {
    commonSetting() {
      this.initTypeName();
    },
    async currentCourse() {
      await this.getCourseDetail();
    },
  },
  async created() {
    // 不影响渲染
    this.lastActiveCollapseArr = [];
    let type = this.$route.query.type;
    this.current = (type || 1).toString();
    await this.setVipTip();
    await this.getData();
    if (this.types.length > 0 && this.types.filter((t) => t.type == this.current).length == 0) {
      this.current = this.types[0].type.toString();
      await this.getData();
    }
    triggerLoaded(this);
  },
  mounted() {
    window.addEventListener('scroll', this.handleScroll);
    // 延迟上报
    setTimeout(() => {
      this.$webSeeSendTrack({
        event_id: 'my_courses_page_show',
      });
    }, 500);
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.handleScroll);
  },
  methods: {
    async handleCollapseChange(activeNames) {
      const { added } = util.findTwoArrayChanges(this.lastActiveCollapseArr, activeNames);
      const addChapterId = added[0];
      const findChaterItem = this.detail.chapters.find((item) => item.id === addChapterId);
      this.lastActiveCollapseArr = activeNames;
      if (addChapterId && !findChaterItem.periods.length) {
        findChaterItem.chapterLoading = true;
        const { periods } = await this.$http.get(
          '/api/app/myStudy/course/chapter/periods',
          {
            courseChapterId: addChapterId,
            courseId: this.currentCourse.course_id,
          },
          {
            showLoading: false,
          },
        );
        // 调整对应课节
        findChaterItem.periods = periods.filter((p) => p.parent_id != 0);
        findChaterItem.periods.forEach((child) => {
          this.formatPerid(child);
        });
        findChaterItem.chapterLoading = false;
        this.detail = { ...this.detail };
        await this.getHomeworkByPeriodIds();
      }
    },
    async changePage(page) {
      this.pageNum = page;
      await this.getCourseDetail(this.pageNum);
      this.activeNames = [];
      this.lastActiveCollapseArr = [];
    },
    handleScroll() {
      const scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
      if (scrollTop > this.courseOffsetTop) {
        this.isSticky = true;
      } else {
        this.isSticky = false;
      }
    },
    handleGetMouse(teacher, type) {
      if (!teacher.wechat_work_qr_code) return;
      this.showHoverQRCode = type === 'over';
    },
    handleVisibelChange(val) {
      if (val) {
        this.showDropUp = true;
        this.attrTitleOnColor = true;
      } else {
        this.showDropUp = false;
        this.attrTitleOnColor = false;
      }
    },
    handleSelectCourseAttr(command) {
      this.attrTitle = command.name;
      this.attrTitleOnColor = true;
      this.changeType(command.value);
    },
    initTypeName() {
      this.types.forEach((t) => {
        if (t.type == 1 || t.type == 2 || t.type == 3 || t.type == 11) {
          return;
        }
        t.name = this.commonSetting.course_name[t.type];
      });
    },
    async setVipTip() {
      let user = await this.$http.get('/api/app/userInfo');
      this.user = user;
      let vip = user.vip;
      if (vip && vip.vip_end_at) {
        let end = new Date(vip.vip_end_at * 1000);
        this.vipEndDate = end.format('yyyy年MM月dd日');
        this.vipEndDateCount = parseInt(
          (end.getTime() - new Date().getTime()) / (24 * 60 * 60 * 1000),
        );
        if (this.vipEndDate >= new Date().format('yyyy-MM-dd')) {
          this.isVipUser = true;
        }
      }
    },
    async getData() {
      // if (this.type == "hidden" || this.type == "expire") {
      //   this.current = "1";
      // }
      let data = await this.$http.get('/api/app/myStudy/' + this.current + '?type=' + this.type);
      data.typeNum = data.typeNum.filter((i) => i.num !== 0);
      data.typeNum.forEach((t) => {
        t.type = t.type.toString();
      });
      this.types = data.typeNum;
      this.initTypeName();
      if (this.$store.state.commonSetting.switch_vip_module !== 1) {
        for (let i = 0; i < this.types.length; i++) {
          if (this.types[i].type == 11) {
            this.types.splice(i, 1);
            break;
          }
        }
      }
      this.vipCourseCount = data.courseList.filter((c) => c.is_vip_course == 1).length;
      // 格式化 公开课时间
      if (this.current == 3) {
        data.courseList.forEach((item) => {
          item.end_play_date =
            this.$pub.tsToTime(item.start_play_date, false).split(' ')[0] ==
            this.$pub.tsToTime(item.end_play_date, false).split(' ')[0]
              ? this.$pub.tsToTime(item.end_play_date, false).split(' ')[1]
              : this.$pub.tsToTime(item.end_play_date, false);
          item.start_play_date = this.$pub.tsToTime(item.start_play_date, false);
        });
      }
      // 设置showHover默认值
      data.courseList.forEach((item) => (item.showHover = false));
      this.courses = data.courseList;
      if (data.courseList.length > 0) {
        let id = this.$route.query.id;
        let i = 0;
        if (id) {
          for (; i < data.courseList.length; i++) {
            if (data.courseList[i].course_id == id) {
              this.currentCourse = data.courseList[i];
              this.navLeftIndex = parseInt(i / 2);
              this.currentIndex = i;
              break;
            }
          }
        }
        if (!id || i == data.courseList.length) {
          this.currentCourse = data.courseList[0];
          this.navLeftIndex = 0;
          this.currentIndex = 0;
        }
        setTimeout(() => {
          this.courseOffsetTop = this.$refs.courses.getBoundingClientRect().top;
        });
      }
      // else if (this.types.length > 0) {
      //   this.current = this.types[0].type;
      //   await this.getData();
      // }
      else {
        this.currentCourse = {};
        this.navLeftIndex = 0;
        this.currentIndex = 0;
        this.courseOffsetTop = 0;
      }
    },
    async changeCourse(index) {
      this.currentCourse = this.courses[index];
      this.currentIndex = index;
      this.$webSeeSendTrack({
        event_id: 'my_courses_item_click',
        event_type: 'click',
        data: {
          course_id: this.currentCourse.course_id,
          course_title: this.currentCourse.title,
        },
      });
    },
    async changeTab(item) {
      this.current = item.name;
      await this.getData();
    },
    navLeft() {
      if (this.navLeftIndex == 0) {
        return;
      }
      this.navLeftIndex--;
    },
    navRight() {
      if (this.navLeftIndex >= this.courses.length - 1) {
        return;
      }
      this.navLeftIndex++;
    },
    formatPerid(perid) {
      let teacherNames = [];
      perid.teachers.forEach((t) => {
        teacherNames.push(t.teacher_name);
      });
      perid.teacher_name = teacherNames.join(',');
      let files = [];
      if (perid.datum && perid.datum.length > 0) {
        perid.datum.forEach((item) => {
          files.push({
            file_name: item.file_name,
            datum_id: item.datum_id,
            fid: item.fid.split(';'),
            file_ext: util.getFileType(item.file_name),
          });
        });
      }
      perid.files = files;
    },
    async getCourseDetail(pageNum = 0) {
      if (!this.currentCourse.course_id) {
        this.detail = {};
        return;
      }
      if (
        this.currentCourse.is_vip_course == 1 &&
        !this.isVipUser &&
        this.currentCourse.is_buy_order == 0
      ) {
        this.detail = {};
        this.vipDialogInfo = '您的会员已失效';
        this.showVipDialog = true;
        return;
      }
      await this.getExam();
      // const data = await this.$http.get('/api/app/myStudy/course/' + this.currentCourse.course_id);
      // 章节外显需求，改用新接口
      const data = await this.$http.get(
        '/api/app/myStudy/course/v2/' + this.currentCourse.course_id,
        {
          pageNum,
          pageSize: PAGE_SIZE,
        },
      );
      // 设置分页
      this.totalPage = data.total_page;
      this.pageNum = data.page_num;
      // 课节作业状态初始化
      if (data.periods) {
        data.periods.forEach((item) => (item.homework = null));
      }
      if (data.course && data.course.teacher_name) {
        data.course.teacher_name = data.course.teacher_name
          .split(',')
          .map((item) => item.substr(0, 6));
      }
      this.detail = data;
      this.activeNames = [];
      this.lastActiveCollapseArr = [];
      // let chapterExpand = {};
      if (this.detail.chapters) {
        this.detail.chapters.forEach((c) => {
          // chapterExpand[c.id] = 0;
          if (!c.periods) {
            c.periods = [];
            return;
          }
          // c.periods = c.periods.filter((p) => p.parent_id != 0);
          // c.periods.forEach((child) => {
          //   this.formatPerid(child);
          // });
        });
      } else if (this.detail.periods) {
        this.detail.periods = this.detail.periods.filter((p) => p.parent_id != 0);
        this.detail.periods.forEach((p) => {
          this.formatPerid(p);
        });
        await this.getHomeworkByPeriodIds();
      }
      if (this.detail.anchor_id) {
        setTimeout(() => {
          this.scrollToAnchorPeriod();
        }, 500);
      }
      // this.chapterExpand = chapterExpand;
      let courseQrcode = await this.$http.get(
        '/api/app/myStudy/courseQrcode/' + this.currentCourse.course_id,
      );
      this.course_qrcode_title = courseQrcode.code_title;
      this.course_qrcode_img = courseQrcode.code_img;
      if (this.detail.cert.length > 0) {
        this.$refs.cert.show(this.detail.cert);
      }
      this.$webSeeSendTrack({
        event_id: 'my_courses_item_detail_show',
        data: {
          course_id: this.currentCourse.course_id,
          course_title: this.currentCourse.title,
        },
      });
    },
    scrollToAnchorPeriod() {
      const $ = window.$;
      const ahchorPeriodOffset = $('#' + this.detail.anchor_id).offset();
      if (ahchorPeriodOffset) {
        const top = $('#' + this.detail.anchor_id).offset().top - 306;
        $('html, body').animate({ scrollTop: top }, 800);
      }
    },
    async getHomeworkByPeriodIds() {
      const res = await this.$http.get(
        `/api/app/study/period?course_id=${this.currentCourse.course_id}`,
        {},
        {
          showLoading: false,
        },
      );
      if (res) {
        const { homework } = res;
        if (homework) {
          if (this.detail.is_show_chapter) {
            this.detail.chapters.forEach((c) => {
              c.periods.forEach((child) => {
                child.homework = homework[child.period_id];
              });
            });
          } else {
            this.detail.periods.forEach((item) => {
              item.homework = homework[item.period_id];
            });
          }
          this.detail = JSON.parse(JSON.stringify(this.detail));
        }
      }
    },
    async deleteCourse() {
      if (this.type == 'open') {
        let cancel = false;
        await this.$confirm('隐藏后，可在“我的课程-隐藏列表”中查看和恢复', '提示', {
          type: 'warning',
        }).catch(() => {
          cancel = true;
        });
        if (cancel) return;
      }
      await this.$http.delete('/api/app/myStudy/course/' + this.currentCourse.course_id);
      if (this.type == 'hidden') {
        await this.$success('取消隐藏成功');
      }
      await this.getData();
    },
    async beginComment() {
      this.commentInfo.grade = 5;
      this.commentInfo.content = '';
      if (this.detail.course.is_comment == 1) {
        let data = await this.$http.get('/api/app/myStudy/comment/' + this.detail.course.course_id);
        this.commentInfo.grade = data.grade;
        this.commentInfo.content = data.content;
      }
      this.showCommentDialog = true;
    },
    async submitComment() {
      if (this.detail.course.is_comment == 1) {
        this.showCommentDialog = false;
        return;
      }
      if (this.commentInfo.grade == 0) {
        await this.$info('请选择星级');
        return;
      }
      if (this.commentInfo.content == '') {
        await this.$info('请输入评价内容');
        return;
      }
      await this.$http.post('/api/app/myStudy/comment', {
        grade: this.commentInfo.grade,
        content: this.commentInfo.content,
        course_id: this.detail.course.course_id,
        type: 1,
      });
      this.showCommentDialog = false;
      if (this.current == 3) {
        this.getData();
      } else {
        this.detail.course.is_comment = 1;
      }
      await this.$success('评价成功');
    },
    // toggleExpand(id) {
    //   if (this.chapterExpand[id] == 0) {
    //     this.chapterExpand[id] = 1;
    //   } else {
    //     this.chapterExpand[id] = 0;
    //   }
    // },
    async changeType(type) {
      this.type = type;
      await this.getData();
    },
    async getExam() {
      this.exams = await this.$http.get(`/api/app/course/getTest/${this.currentCourse.course_id}`);
    },
  },
};
</script>
<style lang="scss" scoped>
@import '../../css/member-study.scss';
::v-deep {
  .el-tabs__header {
    margin-bottom: 0px;
  }
}
::v-deep {
  .chapter-collapse {
    border: none;
    .chapter-collapse-title {
      margin-right: 8px;
      display: flex;
      flex: 1;
      justify-content: space-between;
      align-items: center;
      .show-name {
        font-family: 'PingFang SC';
        font-size: 20px;
        font-style: normal;
        font-weight: 500;
        line-height: 28px;
        color: #1d1b20;
      }
      .show-count {
        color: #54535c;
        font-family: 'PingFang SC';
        font-size: 14px;
        font-style: normal;
        font-weight: 400;
        line-height: 20px;
      }
    }
    .el-collapse-item__header {
      height: auto;
      line-height: 0;
      border-bottom: none;
    }
    .el-collapse-item {
      padding: 16px;
      box-shadow: 0px 2px 4px -2px rgba(24, 39, 75, 0.12), 0px 4px 4px -2px rgba(24, 39, 75, 0.08);
      border: 1px solid #f1f3f9;
      border-radius: 8px;
      margin-bottom: 24px;
    }
    .el-collapse-item:last-child {
      margin-bottom: 0;
    }
    .el-collapse-item__wrap {
      padding-top: 16px;
      padding-left: 12px;
      border-bottom: none;
    }
    .el-collapse-item__arrow {
      margin-right: 0;
      &::before {
        content: '';
        width: 16px;
        height: 16px;
        display: inline-block;
        background: url('~@stu/images/collapse-down.png');
        background-size: cover;
      }
    }
    .el-collapse-item__arrow.is-active {
      -webkit-transform: rotate(-180deg);
      transform: rotate(-180deg);
      transform-origin: center;
    }
  }
}
.onshowUpIcon :deep(.el-icon-caret-bottom:before) {
  content: '\E78f';
}
:deep(.el-tabs__item) {
  margin-right: 56px;
  color: #1a1a1a;
}
:deep(.el-tabs__item.is-active::after) {
  height: 2px;
  width: 24px !important;
  border-radius: 2px;
  background: #f4242e;
  left: 50% !important;
  transform: translateX(-75%) !important;
}
.onColor {
  color: #f4242e;
}
.onBackGround {
  background-color: rgba(244, 36, 46, 0.1) !important;
}
:deep(.el-dropdown-menu__item:hover) {
  background-color: #fff;
}
</style>
